import ApiHttp from '../http';
import {Seat, SeatGroups} from '../../model';

class SeatGridService {

    /**
     * Service for interacting with the seat plan api
     */
    constructor() {
        this.seatGrid = undefined;

    }

    getSeatGrid(cinema_id, session_id, tickets = null) {

        return this.seatGrid = ApiHttp.get(`/seats/` + cinema_id + `/` + session_id).then((result) =>(this._generateGrid(result.data, tickets)),
                (error) => (
                    this.seatGrid = undefined
                ))
    }

    _generateGrid(SeatData, tickets = null) {

        // console.log("SeatData - seat-grid-service", SeatData)
        var grid = [];
        var selectedSeats = [];


        for (var i = 0; i < SeatData.Areas.length; i++) {
            var area = SeatData.Areas[i];

            // add an empty row with one empty seat to separate areas
            if (i > 0) grid.push({
                PhysicalName: undefined, Seats: [{
                    seatNumber: 0,
                    empty: true,
                    size: 1,
                    Position: {
                        AreaNumber: area.Number,
                        AreaCategoryCode: SeatData.AreaCategories[0].AreaCategoryCode,
                        ColumnIndex: null,
                        RowIndex: null,
                    },
                    seats: [{empty: true}]
                }]
            });

            /* determine the number of rows for the area by the maximum number of seats (to avoid large white spaces)*/
            var numSeatsPerRow = Math.max.apply(Math, area.Rows.map((a)=> {
                // get the max column index of the seats: (to ensure the total number of rows is exact to the number of seats at their actual positions.
                var maxColIndex = Math.max.apply(Math, a.Seats.map((s)=>s.Position.ColumnIndex));
                return a.Seats.length > maxColIndex ? a.Seats.length : maxColIndex
            }));
            // loop rows
            for (var j = area.Rows.length - 1; j >= 0; j--) {
                var row = area.Rows[j],
                    rowSeats = [],
                    seats = row.Seats.reduce((col, seat)=> {
                        col[seat.Position.ColumnIndex] = seat;
                        return col;
                    }, []);


                for (var k = numSeatsPerRow; k >= 0; k--) {
                    var seat = seats[k],
                        seatObj = {
                            seatNumber: Number((seat && seat.Id || 0)),
                            seatNumberCombined: [(numSeatsPerRow - (k - 1))],
                            seatName: row.PhysicalName + (seat && seat.Id || 0),
                            seatNameCombined: [row.PhysicalName + (seat && seat.Id || 0)],
                            selected: false,
                            Position: {
                                AreaCategoryCode: area.AreaCategoryCode,
                                AreaNumber: area.Number,
                                ColumnIndex: seat && seat.Position.ColumnIndex || null,
                                RowIndex: seat && seat.Position.RowIndex || null,
                            },
                            empty: !(seat) || !!(~[2, 4, 5, 6].indexOf(seat.Status)),
                            available: seat && !(~[1, 2, 4, 5, 6].indexOf(seat.Status)),
                            loveNest: seat && ( (seat.SeatStyle === 1 || seat.SeatStyle === 2 || seat.SeatStyle === 3)),
                            companion: seat && seat.Status === 7,
                            wheelchair: seat && seat.Status === 3,
                            size: seat && seat.SeatsInGroup && seat.SeatsInGroup.length || 1,
                            seats: []

                        };

                    if (seatObj.empty) {
                        seatObj.type = 0
                    } else if (seatObj.loveNest) {
                        seatObj.type = 2
                    } else if (seatObj.wheelchair) {
                        seatObj.type = 3;
                    } else if (seatObj.companion) {
                        seatObj.type = 4;
                    } else {
                        seatObj.type = 1;
                    }

                    if(seat && seat.Position){
                        seat.Position.AreaCategoryCode = area.AreaCategoryCode;
                    }
                    //check if seat in tickets matches this seat.

                    var ticket = tickets.find((ticket)=>ticket.SeatData === seatObj.seatName)
                    if (ticket) {
                        seatObj.available = true;
                        seatObj.selected = true;
                        seatObj.price = ticket.PriceCents / 100;
                        seat.ticket = ticket;
                        ticket.Position = seat.Position;
                        selectedSeats.push(seatObj);
                    }
                    // add this seat to the seatObj.
                    seatObj.seats.push(seat)

                    //according to vista docs SEATSTYLE = 1 is a seat style for the left hand side of a grouped seat.
                    if (seat && seat.SeatStyle == 1) {
                        var m = k - 1;
                        // go back and add grouped seats to this seat object
                        while (seats[m] && seats[m].SeatStyle > 1) {
                            var seatName =row.PhysicalName + seats[m].Id ;
                            var ticket = tickets.find((ticket)=>ticket.SeatData === seatName)
                            if(ticket){
                                seat.ticket = ticket;
                                ticket.Position = seat.Position;
                            }
                            seatObj.seats.push(seats[m]);
                            seatObj.seatNumberCombined.push(Number(seats[m].Id));
                            seatObj.seatNameCombined.push(seatName);
                            m--;
                        }
                        // reset the index to after these group seats.
                        k = m + 1;
                    }


                    rowSeats.push(seatObj);

                }

                grid.push({PhysicalName: row.PhysicalName, Seats: rowSeats, rowData: row});

            }
        }
        // this.seatGrid = {grid, selectedSeats};
        return {grid, selectedSeats};
        // return this._drawGrid(SeatData);
    }


    _drawGrid(areaObj) {
        var areaGrids = [];

        for (let area of areaObj.Areas) {
            var grid = [];
            for (var r = 0; r < area.RowCount; r++) {
                var row = {data: [], PhysicalName: null};
                for (var c = 0; c < area.ColumnCount; c++) {
                    row.data.push([]);
                }

                grid.push(row);
            }
            var mappedGrid = this._mapGrid(grid, area);
            areaGrids.push(mappedGrid);
        }

        // var mappedGrids = [];
        // for(let grid of areaGrids) {
        //     var mappedGrid = this._mapGrid(grid, areaObj);
        // }

        // console.log(areaGrids);
        // var mappedGrids = this._mapGrid(areaGrids, areaObj);


        // console.log(areaGrids);
        return areaGrids.reverse();
    }

    _mapGrid(grid, area) {
        var rows = area.Rows
        var Seats = []
        for (var r = 0; r < grid.length; r++) {
            var seats = area.Rows[r].Seats;
            if (area.Rows[r] != undefined)
                grid[r].PhysicalName = area.Rows[r].PhysicalName;

            for (var c = 0; c < grid[r].data.length; c++) {
                var hasSeat = false
                for (let seat of seats) {
                    if (seat.Position.ColumnIndex == c && seat.Position.RowIndex == r) {

                        var SeatData = new Seat(seat);
                        Seats.push(SeatData);
                        var SeatGroup = this._groupSeat(SeatData, Seats);

                        var seatData = {empty: false, data: SeatGroup}
                        hasSeat = true
                    }
                }

                if (!hasSeat) {
                    var seatData = {empty: true, data: []}
                }
                grid[r].data[c] = seatData;
            }

            grid[r].data.reverse();
        }

        return grid.reverse();
    }

    /**
     ** Group seats for Display Purposes and Selection.
     ** Active {Whether the seat can be booked or not}
     ** Types {Normal: 1, LoveNest: 2, WheelChair: 3, Companion: 4}
     **/
    _groupSeat(Seat, Seats) {
        // console.log(Seats);
        // console.log(Seat);

        var active = true;
        var type = 1; //1 => Normal, 2=> Lovenest, 3=> Wheelchair, 4=>Companion
        var addToGroup = true;
        var size = 1;

        if (Seat.Status === 0) { //Empty Seat
            active = true;
        } else if (Seat.Status === 1) { //Sold Seat
            active = false;
        } else if (Seat.Status === 2) { //House Seat
            active = false;
        } else if (Seat.Status === 3) { //Special Seat
            active = true;
            type = 3;
        } else if (Seat.Status === 4) { //Reserved Seat
            active = false;
        } else if (Seat.Status === 5) { //Broken Seat
            active = false;
        } else if (Seat.Status === 6) { //Placeholder Seat
            active = false;
        } else if (Seat.Status === 7) { //Companion Seat
            active = true;
            type = 4;
        }


        if (Seat.SeatStyle > 0) {

            if (Seat.SeatStyle === 1 || Seat.SeatStyle === 2 || Seat.SeatStyle === 3) {
                type = 2;

                if (Seat.SeatStyle === 1) {
                    size = Seat.SeatsInGroup.length;
                }
            }

            if (Seat.SeatStyle > 1) {
                addToGroup = false;
            }
        }

        if (addToGroup) {
            var seatGroup = {};
            seatGroup.Size = size;
            seatGroup.Empty = true;
            seatGroup.Active = active;
            seatGroup.SeatType = type;
            seatGroup.SeatData = Seat;
            seatGroup.Selected = false;
            seatGroup.SeatsInGroup = Seat.SeatsInGroup || [];
            seatGroup.ColumnIndex = Seat.Position.ColumnIndex;
            seatGroup.RowIndex = Seat.Position.RowIndex;
            seatGroup.AreaNumber = Seat.Position.AreaNumber;

            var Seat_Group = new SeatGroups(seatGroup);

            return Seat_Group;
        }
    }

    checkGapSeats(selectedSeats, areaGrid) {
        var rows = []
        for (let selectedSeat of selectedSeats.data) {
            rows.push({
                ColumnIndex: selectedSeat.ColumnIndex,
                RowIndex: selectedSeat.RowIndex,
                AreaNumber: selectedSeat.AreaNumber,
                SeatType: selectedSeat.SeatType,
                Size: selectedSeat.Size
            })
        }

        return this._checkAvailableGapSeats(rows.reverse(), this._flattenGrid(areaGrid));
    }

    _checkAvailableGapSeats(rows, flatGrid) {
        var nextSeat = {}
        var seat = {}
        var hasGapSeat = false;

        for (var i = 0; i < rows.length; i++) {
            seat = rows[i]

            if (i < rows.length)
                nextSeat = rows[i - 1]
            else
                nextSeat = null

            if (nextSeat != null) {
                if (nextSeat.RowIndex == seat.RowIndex && nextSeat.AreaNumber == seat.AreaNumber) {
                    if (seat.ColumnIndex - nextSeat.ColumnIndex > seat.Size) {
                        hasGapSeat = this._gapHasActiveSeats(seat, nextSeat, flatGrid)
                        if (hasGapSeat)
                            return hasGapSeat
                    }
                }
            }
        }
    }

    _flattenGrid(areaGrid) {
        var grid = []

        for (let area of areaGrid) {
            for (let row of area) {
                for (let seat of row.data) {
                    if (!seat.empty) {
                        if (seat.data != undefined) {
                            if (seat.data.data != undefined) {
                                grid.push({
                                    AreaNumber: seat.data.data.AreaNumber,
                                    RowIndex: seat.data.data.RowIndex,
                                    ColumnIndex: seat.data.data.ColumnIndex,
                                    data: seat.data.data
                                })
                            }
                        }
                    }
                }
            }
        }

        return grid
    }

    _gapHasActiveSeats(seat, nextSeat, flatGrid) {
        var hasActiveSeats = false
        for (let gridSeat of flatGrid) {

            if ((gridSeat.AreaNumber == seat.AreaNumber) && (gridSeat.RowIndex == seat.RowIndex) && (gridSeat.AreaNumber == nextSeat.AreaNumber) && (gridSeat.RowIndex == nextSeat.RowIndex)) {
                if ((gridSeat.ColumnIndex < seat.ColumnIndex) && (gridSeat.ColumnIndex > nextSeat.ColumnIndex)) {
                    // console.log(gridSeat.data.Active)
                    if (gridSeat.data.Active)
                        return gridSeat.data.Active
                }
            }
        }

        return false
    }

    _seatsInGap(seat, nextSeat, flatGrid) {
        var seatsInGap = []

        for (let gridSeat of flatGrid) {
            // console.log("_seatsInGap", seat, nextSeat, "Match?", gridSeat)
            if ((gridSeat.AreaNumber == seat.AreaNumber) && (gridSeat.RowIndex == seat.RowIndex) && (gridSeat.AreaNumber == nextSeat.AreaNumber) && (gridSeat.RowIndex == nextSeat.RowIndex)) {
                if ((gridSeat.ColumnIndex > seat.ColumnIndex) && (gridSeat.ColumnIndex < nextSeat.ColumnIndex)) {
                    seatsInGap.push(gridSeat)
                }
            }
        }

        return seatsInGap;
    }
}

export default new SeatGridService();


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/service/seat-grid-service.js